import { render, staticRenderFns } from "./SelTable.vue?vue&type=template&id=31e704cb&scoped=true&"
import script from "./SelTable.vue?vue&type=script&lang=js&"
export * from "./SelTable.vue?vue&type=script&lang=js&"
import style0 from "./SelTable.vue?vue&type=style&index=0&id=31e704cb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31e704cb",
  null
  
)

export default component.exports